import {
   PatientContinuouslyUsedMedicineDeleteCommand,
   PatientMedicine,
} from '@dreryk/egabinet-prescription-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

export const useDeleteContinuouslyUsedMedicine = (
   continuouslyUsedMedicineId: PatientMedicine['patientContinuouslyUsedMedicineId'],
   onMedicineDeleted: (id: PatientMedicine['patientContinuouslyUsedMedicineId'] | undefined) => void
): UseCqrsCommandResult<void> => {
   return useCqrsCommand(
      () => {
         const command = new PatientContinuouslyUsedMedicineDeleteCommand();
         command.patientContinuouslyUsedMedicineId = continuouslyUsedMedicineId!;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               translationKeys.medicine.continuouslyUsedMedicine.successfullyDeletedContinuouslyUsedMedicine
            );
            onMedicineDeleted(undefined);
         },
      }
   );
};
